// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-layout-header[data-v-2187d25c]{color:#fff;background:#3880bb}.logo[data-v-2187d25c]{width:230px;height:70px;margin-left:50px;margin-top:-10px}.login[data-v-2187d25c]{width:30px;height:30px;background-color:#fff;border-radius:30px}#login[data-v-2187d25c]{float:right;color:#fff}.home[data-v-2187d25c]{cursor:pointer;margin-left:15px}.home[data-v-2187d25c]:hover{color:#6495ed}", ""]);
// Exports
module.exports = exports;
